// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_k3-0";